'use client';

import React from 'react';
import { DRIFT_TOKEN_BANK_INDEX } from 'src/environmentVariables/EnvironmentVariables';
import { useSpotMarketsLookup } from 'src/hooks/spotMarkets/useSpotMarketsLookup';
import ToggleTabs from 'src/components/primitives/ToggleTabs/ToggleTabs';
import Button from 'src/components/primitives/Button/Button';
import StakeFormContent from 'src/components/Staking/StakeFormContent';
import UnstakeFormContent from 'src/components/Staking/UnstakeFormContent';
import useStakeForm from 'src/components/Staking/hooks/useStakeForm';
import useUnstakeForm from 'src/components/Staking/hooks/useUnstakeForm';
import useStakingTabs from 'src/components/Staking/hooks/useStakingTabs';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';

export default function DriftStakingForm() {
	const isMobileScreenSize = useIsMobileScreenSize();
	const { tabOptions, selectedTab, setSelectedTab } = useStakingTabs();

	if (isMobileScreenSize) {
		return null;
	}

	return (
		<div className="flex flex-col gap-y-lg rounded-sm bg-container-bg p-lg">
			<ToggleTabs
				options={tabOptions}
				activeTab={selectedTab}
				onTabChange={setSelectedTab}
				animatedBackgroundClassName="bg-button-primary-bg"
			/>
			{selectedTab === 'stake' && <StakeForm />}
			{selectedTab === 'unstake' && <UnstakeForm />}
		</div>
	);
}

function StakeForm() {
	const driftSpotMarket = useSpotMarketsLookup()[DRIFT_TOKEN_BANK_INDEX];

	const {
		isSubmitDisabled,
		isSubmitting,
		handleSubmit,
		submitButtonContent,
		...stakeFormProps
	} = useStakeForm({
		isDriftStaking: true,
		defaultSelectedMarket: driftSpotMarket,
	});

	return (
		<>
			<StakeFormContent
				isSubmitting={isSubmitting}
				hideUnstakeRequest
				isDriftStaking
				{...stakeFormProps}
			/>
			<Button
				size="xl"
				className="w-full"
				disabled={isSubmitDisabled}
				isLoading={isSubmitting}
				onClick={handleSubmit}
			>
				{submitButtonContent}
			</Button>
		</>
	);
}

function UnstakeForm() {
	const driftSpotMarket = useSpotMarketsLookup()[DRIFT_TOKEN_BANK_INDEX];

	const {
		isSubmitDisabled,
		isSubmitting,
		handleSubmit,
		submitButtonContent,
		...unstakeFormProps
	} = useUnstakeForm({
		isDriftStaking: true,
		defaultSelectedMarket: driftSpotMarket,
	});

	return (
		<>
			<UnstakeFormContent
				isSubmitting={isSubmitting}
				hideUnstakeRequest
				isDriftStaking
				{...unstakeFormProps}
			/>
			<Button
				size="xl"
				className="w-full"
				disabled={isSubmitDisabled}
				isLoading={isSubmitting}
				onClick={handleSubmit}
			>
				{submitButtonContent}
			</Button>
		</>
	);
}
